import { Component, Injector, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { OfferService, PropertyService } from 'api';
import { HouseDetailsBaseComponent } from 'common';
import { Lightbox, LightboxConfig, LightboxEvent } from 'ngx-lightbox';

@Component({
  selector: 'app-house-details',
  templateUrl: './house-details.component.html',
  styleUrls: ['./house-details.component.scss'],
})
export class HouseDetailsComponent extends HouseDetailsBaseComponent {
  @Input() exposed2dSections: string[];

  requestDetailsSent = false;

  collapsed = true;

  constructor(
    injector: Injector,
    route: ActivatedRoute,
    sanitizer: DomSanitizer,
    propertyService: PropertyService,
    _lightbox: Lightbox,
    _lightboxEvent: LightboxEvent,
    _lighboxConfig: LightboxConfig,
    private offerService: OfferService,
  ) {
    super(injector, route, sanitizer, propertyService, _lightbox, _lightboxEvent, _lighboxConfig);
  }

  has2dSection(section: string): boolean {
    if (!this.exposed2dSections) return true;

    return this.exposed2dSections.includes(section);
  }

  requestDetails() {
    this.offerService.requestDetails(
      this.route.snapshot.params['agency_uuid'],
      this.route.snapshot.params['uuid']
    ).then(() => {
      this.requestDetailsSent = true;
    });
  }
}
